import type { ReactNode } from 'react';
import { ApiError } from '@/lib/api/client';
import { Button } from './Button';

export function EmptyState({ title = 'لا توجد بيانات', hint, action }: { title?: string; hint?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-2 px-4 py-10 text-center text-muted">
      <div className="text-3xl opacity-40">∅</div>
      <div className="font-semibold text-ink">{title}</div>
      {hint && <div className="text-xs">{hint}</div>}
      {action}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message = error instanceof ApiError ? error.message : 'تعذر تحميل البيانات';
  return (
    <div className="flex flex-col items-center gap-3 px-4 py-10 text-center">
      <div className="font-semibold text-danger">{message}</div>
      {onRetry && (
        <Button size="sm" onClick={onRetry}>
          إعادة المحاولة
        </Button>
      )}
    </div>
  );
}
